// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

const UserListController = function ($rootScope, $scope, $http, $location, PUtill, User, UserResendConfirmation, gettextCatalog, gettext, IdentityProviderSettings) {

    $scope.ExternalRoleAssignmentStrategy = Object.freeze({
        "NoExternalRoleAssignments": "NoExternalRoleAssignments",
        "RolePerLegalEntity": "RolePerLegalEntity",
        "OneRoleForAllLegalEntities": "OneRoleForAllLegalEntities"
    });

    $scope.ThirdPartyIntegrations = Object.freeze({
        "OpenIdConnect": "OpenIdConnect",
        "AzureActiveDirectory": "AzureActiveDirectory"
    });
    
    $scope.isTenant = function () {
        return $rootScope.features.TenantHierarchy;
    }

    $scope.isSsoUser = function (user) {
        return user.UserType === "External";
    }

    $scope.isSsoFeature = function () {
        return $rootScope.features.OpenIdConnect || $rootScope.features.AzureActiveDirectory;
    }

    $scope.getUserTypeName = function (userType) {

        if (userType === "External") {
            return "Single Sign On"
        }
        return userType;
    }

    const multiSelectStates = Object.freeze({
        NonInitialized : 0,
        OutputAsTree : 1,
        PendingForSearch : 2,
        SearchResultAsList : 3,
        SearchResultAsTree : 4,
    })

    const pageSize = 100;

    $scope.TenantEntities = {
        items: [],
        newState: multiSelectStates.NonInitialized
    }

    $scope.filterModel = {
        Search: null,
        Role: '',
        Confirmed: '',
        EntityId: null,
        UserType: ''
    }

    $scope.roleName = PUtill.getText('Roles');
    $scope.confirmedFilterTitle = PUtill.getText('Confirmation');
    $scope.searchString = '';
    $scope.typeName = PUtill.getText('Types');

    $scope.setRoleFilterAndFetch = function (selectedRole, defaultLabelName) {
        if(selectedRole === 'All')
        {
            selectedRole = '';
        }
        $scope.filterModel.Role = selectedRole.replace(' ', '');
        $scope.roleName = PUtill.getText(defaultLabelName || selectedRole);
        $scope.updateFilter();
    };

    $scope.setUserTypeFilterAndFetch = function (selectedType, defaultLabelName) {
        if(selectedType === 'All')
        {
            selectedType = '';
        }
        $scope.filterModel.UserType = selectedType.replace(' ', '');
        $scope.typeName = PUtill.getText(defaultLabelName || selectedType);
        $scope.updateFilter();
    };

    $scope.setConfirmedFilterAndFetch = function(selectedConfirmationFilterVariant, defaultLabelName) {

        switch (selectedConfirmationFilterVariant) {
            case 'All':
                $scope.filterModel.Confirmed = null;
                break;
            case 'Confirmed':
                $scope.filterModel.Confirmed = true;
                break;
            case 'Unconfirmed':
                $scope.filterModel.Confirmed = false;
                break;
        }
        $scope.confirmedFilterTitle = PUtill.getText(defaultLabelName || selectedConfirmationFilterVariant);
        $scope.updateFilter();
    };

    $scope.setSearchFilterAndFetch = function(typedSearchString) {
        $scope.filterModel.Search = typedSearchString;
        $scope.updateFilter();
    };

    $scope.unsetSearchFilterAndFetch = function() {
        $scope.searchString = '';
        $scope.filterModel.Search = '';
        $scope.updateFilter();
    };

    $scope.setEntityFilterAndFetch = function() {
        if($scope.selectedEntity[0]) {
            $scope.filterModel.EntityId = $scope.selectedEntity[0].Id;
            $scope.updateFilter();
        }
        else {
            $scope.filterModel.EntityId = null;
            $scope.updateFilter();
        }
    }

    $scope.updateFilter = function()
    {
        $scope.users = $scope.paginator(function (options, callback) {
            return User.query(options, function () {
                callback();
                mapUsersMandateWithEntitiesNames();
                $scope.wasSearching = options.search;
            });
        }, $scope.filterModel, 20, true);
    }

    $scope.$on('refresh', function(event) {
        load();
    });

    $scope.deleteUser = function (id) {
        $scope.yesCancel(gettextCatalog.getString(gettext('Delete User Account?')),
            gettextCatalog.getString(gettext('Are you sure?')),
            function () { User.delete({ id: id }, load); });
    };

    $scope.resendConfirmation = function (id) {
        UserResendConfirmation.save( {userId:id}, {}, function() {
            $scope.notify("success", gettextCatalog.getString(gettext("Confirmation request mail resent successfully")));
        } );
    };
    
    $scope.invite = function () {
        $location.path("/account-settings/invite-user");
    }

    $scope.$watch('selectedEntity', function (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
            $scope.setEntityFilterAndFetch();
        }
    });

    load();

    $scope.loadEntitiesForSelectTree = function (searchQuery, searchEntityId, treeState){
        createCanEditUserFunction();
        if ($scope.isTenant()) {
            $http.get('/api/v1/legalEntities', {
                params: {
                    take: pageSize,
                    entityId: searchEntityId,
                    search: searchQuery
                }
            }).then(function (result) {
                switch (treeState) {
                    case multiSelectStates.NonInitialized:
                        $scope.enList = result.data;
                        mapUsersMandateWithEntitiesNames();
                    case multiSelectStates.OutputAsTree:
                        $scope.TenantEntities.items = convertEntityListToTree(result.data);
                        $scope.TenantEntities.newState = multiSelectStates.OutputAsTree;
                        break;
                    case multiSelectStates.PendingForSearch:
                        $scope.TenantEntities.items = result.data;
                        $scope.TenantEntities.newState = multiSelectStates.SearchResultAsList;
                        break;
                    case multiSelectStates.SearchResultAsList:
                        if (searchEntityId) {
                            result.data[0].ParentId = null;
                            $scope.TenantEntities.items = convertEntityListToTree(result.data);
                            $scope.TenantEntities.newState = multiSelectStates.SearchResultAsTree;
                        }
                        break;
                }
            });
        }
    }

    function mapUsersMandateWithEntitiesNames() {
        for (let i = 0; i < $scope.users.items.length; i++) {
            for (let j = 0; j < $scope.users.items[i].Mandates.length; j++) {
                let currentEntity = $scope.enList.find(function (entity) {
                    return entity.Id === $scope.users.items[i].Mandates[j].EntityId;
                });
                let roles = $scope.users.items[i].Mandates[j].Roles.join(",");
                if (!$scope.users.items[i].UserRolesByLegalEntityName) {
                    $scope.users.items[i].UserRolesByLegalEntityName = [];
                }
                $scope.users.items[i].UserRolesByLegalEntityName.push({name: currentEntity.Name, roles: roles})
            }
        }
    }

    function load() {
        $http.get('/api/v1/users/roles').then(function (result) {
            $scope.roles = result.data
        });
        $scope.users = $scope.paginator(function (options, callback) {
            return User.query(options, function () {
                callback();
                $scope.loadEntitiesForSelectTree('', null, multiSelectStates.NonInitialized);
                $scope.wasSearching = options.search;
            });
        }, $scope.filterModel, 20, true);
    }

    //TODO: review. Convert list of entities to tree structure and return it 
    //duplicate from UserStateController
    function convertEntityListToTree(list) {
        let map = {}, node, roots = [], i;

        for (i = 0; i < list.length; i += 1) {

            //Hack - here added some props, which will be needed later. 
            // Better move it from here to separate method
            list[i].name = list[i].Name;
            if (!$scope.IsEditMode) {
                list[i].Roles = [];
            }

            map[list[i].Id] = i;
            list[i].children = [];
        }

        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node.ParentId) {
                list[map[node.ParentId]].children.push(node);
            } else {
                roots.push(node);
            }
        }
        return roots;
    }

    function createCanEditUserFunction() {
        if ($scope.isSsoFeature()) {
            IdentityProviderSettings.get().$promise.then(function (response) {
                let ssoSettingsActive = response?.Active && response?.Valid;
                let isNoRoleAssignment = response?.ExternalRoleAssignmentStrategy === $scope.ExternalRoleAssignmentStrategy.NoExternalRoleAssignments;
                let isAzure = response?.ThirdPartyIntegration === $scope.ThirdPartyIntegrations.AzureActiveDirectory;
                $scope.canEditUser = function (user) {
                    return user.UserType === "Internal" || !ssoSettingsActive || isNoRoleAssignment || !isAzure;
                }
            });
        }
        else {
            $scope.canEditUser = function () {
                return true;
            }
        }
    }
};
UserListController.$inject = ['$rootScope','$scope', '$http','$location', 'PUtill', 'User', 'UserResendConfirmation', 'gettextCatalog', 'gettext', 'IdentityProviderSettings'];
